import { useEffect, useState, useRef } from "react";
import { api } from "@/lib/api";
import { ASSET } from "@/constants/testIds";
import { Upload, Trash2 } from "lucide-react";
import { toast } from "sonner";

export default function Assets() {
  const [items, setItems] = useState([]);
  const fileRef = useRef();

  const load = async () => setItems((await api.get("/assets")).data);
  useEffect(() => { load(); }, []);

  const upload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const fd = new FormData();
    fd.append("file", file);
    fd.append("kind", file.type.startsWith("image") ? "image" : file.type.startsWith("video") ? "video" : "file");
    try {
      await api.post("/assets/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      toast.success("Asset uploaded");
      load();
    } catch { toast.error("Upload failed"); }
    e.target.value = "";
  };

  const del = async (id) => {
    if (!confirm("Delete asset?")) return;
    await api.delete(`/assets/${id}`);
    load();
  };

  return (
    <div className="p-8 space-y-6 max-w-[1500px]">
      <div className="flex items-end justify-between flex-wrap gap-4">
        <div>
          <h1 className="text-3xl font-display text-gray-900">Assets</h1>
          <p className="text-sm text-gray-500 mt-1">Shared brand library: logos, product shots, sounds.</p>
        </div>
        <label className="btn-brand inline-flex items-center gap-2 px-4 py-2 text-sm cursor-pointer">
          <Upload className="h-4 w-4" /> Upload
          <input ref={fileRef} data-testid={ASSET.uploadInput} type="file" onChange={upload} className="hidden" />
        </label>
      </div>

      {items.length === 0 ? (
        <div className="bg-white border border-dashed border-gray-300 rounded-xl p-12 text-center text-sm text-gray-500">
          No assets yet.
        </div>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3">
          {items.map((a) => (
            <div key={a.id} className="bg-white border border-gray-200 rounded-xl overflow-hidden hover:border-gray-300 hover:shadow-sm transition-all">
              <div className="aspect-square bg-gray-50 flex items-center justify-center overflow-hidden">
                {a.content_type?.startsWith("image") ? (
                  <img alt={a.filename} src={`${process.env.REACT_APP_BACKEND_URL}/api/assets/file/${a.id}`}
                    className="w-full h-full object-cover" />
                ) : (
                  <span className="text-[10px] text-gray-400 uppercase tracking-wider">{a.kind}</span>
                )}
              </div>
              <div className="p-2 border-t border-gray-100 flex items-center justify-between gap-1">
                <p className="text-xs truncate text-gray-700">{a.filename}</p>
                <button onClick={() => del(a.id)} className="text-gray-400 hover:text-red-500">
                  <Trash2 className="h-3 w-3" />
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
